import React, { useState } from "react";
import { Button, Modal } from "antd";
import { Field, Form, Formik } from "formik";
import { AntInput, AntTextArea } from "../../hooks/createAntDFields";
import axios from "axios";
import { toast } from "react-toastify";
import REACT_APP from "../../environment";
import { productInitialValue, productValidation } from "../../constants/product";
import { useDispatch } from "react-redux";
import { endWait, startWait } from "../../store/waiting";
import { useTranslation } from "react-i18next";

const CreateProduct = ({ getData }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const validate = productValidation(t);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => setIsModalOpen(true);
    const cancel = (resetForm) => {
        if (typeof resetForm === "function") resetForm();
        setIsModalOpen(false);
    };

    const submit = async (data, { setSubmitting, resetForm }) => {
        dispatch(startWait());
        await axios
            .post(`${REACT_APP.API_URL}/api/hrp/provider/v1/product`, data, { headers: { Authorization: sessionStorage.getItem("token") } })
            .then(() => {
                resetForm();
                toast.success(t("Created!"));
                getData();
                setIsModalOpen(false);
            })
            .catch((err) => {
                console.log(err);
                toast.error(t((err.response?.data?.errors && err.response.data.errors[0]?.message) || err.message));
            });
        setSubmitting(false);
        dispatch(endWait());
    };

    return (
        <>
            <div className="float-right">
                <button
                    onClick={showModal}
                    type="button"
                    className="text-green-700 hover:text-white border border-green-700 hover:bg-green-700 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2 text-center dark:border-green-500 dark:text-green-500 dark:hover:text-white dark:hover:bg-green-500 dark:focus:ring-green-800 transition-all"
                >
                    {t("Create product")}
                </button>
            </div>
            <Formik initialValues={productInitialValue} validationSchema={validate} onSubmit={submit}>
                {({ isSubmitting, submitCount, errors, resetForm }) => (
                    <Modal title={t("Create product")} open={isModalOpen} footer={[]} onCancel={() => cancel(resetForm)}>
                        <div className="pt-4">
                            <Form autoComplete="off">
                                <div>
                                    <label htmlFor="name">{t("Product name")}</label>
                                    <Field component={AntInput} submitCount={submitCount} size="large" name="name" />
                                    <label htmlFor="description">{t("Description")}</label>
                                    <Field
                                        component={AntTextArea}
                                        submitCount={submitCount}
                                        size="large"
                                        name="description"
                                        autoSize={{ minRows: 3, maxRows: 5 }}
                                    />
                                </div>
                                <div className="ant-modal-footer">
                                    <Button onClick={() => cancel(resetForm)}>{t("Cancel")}</Button>
                                    <Button type="primary" htmlType="submit">
                                        {t("Submit")}
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    </Modal>
                )}
            </Formik>
        </>
    );
};
export default CreateProduct;
